import { useCallback, useState } from 'react'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { useGetManagedEntitiesQuery, useUpdateEntityStatusMutation } from '../../../features/entities/entitiesApi'
export const INBOUND = 'isInboundActive'
export const OUTBOUND = 'isOutboundActive'

const EMPTY = []
const useManageEntities = (connectorId, instanceId) => {
    const hasConnector = Boolean(connectorId && instanceId)
    const { data: entities = EMPTY, isLoading, isError, refetch } = useGetManagedEntitiesQuery(
        hasConnector ? { connectorId, instanceId } : skipToken
    )
    const [updateEntityStatus] = useUpdateEntityStatusMutation()
    const [savingId, setSavingId] = useState(null)
    const [status, setStatus] = useState(null)

    const toggleEntity = useCallback((entity, direction, isActive) => {
        setStatus(null)
        setSavingId(entity.id)

        return updateEntityStatus({
            connectorId,
            instanceId,
            entityId: entity.id,
            isInboundActive: entity.isInboundActive,
            isOutboundActive: entity.isOutboundActive,
            [direction]: isActive
        })
            .unwrap()
            .then((data) => {
                setStatus(data.result === false ? { result: false, message: data.message || 'No changes made.' } : { result: true, message: `${entity.displayName} updated successfully.` })
            })
            .catch(() => {
                setStatus({ result: false, message: `Unable to update ${entity.displayName}.` })
            })
            .finally(() => setSavingId(null))
    }, [connectorId, instanceId, updateEntityStatus])

    const reload = useCallback(() => {
        setStatus(null)
        if (hasConnector) {
            refetch()
        }
    }, [hasConnector, refetch])

    const dismissStatus = useCallback(() => setStatus(null), [])

    return {
        entities,
        isLoading: hasConnector && isLoading,
        loadError: isError ? 'Unable to load the entities. Please try again.' : '',
        savingId,
        status,
        toggleEntity,
        dismissStatus,
        reload
    }
}

export default useManageEntities
